import { NgTemplateOutlet } from '@angular/common'
import { Component, computed, contentChild, input, TemplateRef } from '@angular/core'
import { DateComponent, DateFormat, IconComponent } from '@ftr/foundation'
import { FakeCartGroup } from '../fake-cart'

export const CartGroupDisplayTypes = ['small', 'large']
export type CartGroupDisplayType = (typeof CartGroupDisplayTypes)[number]

@Component({
  selector: 'ftr-request-cart-group',
  templateUrl: './request-cart-group.component.html',
  styleUrl: './request-cart-group.component.css',
  imports: [DateComponent, IconComponent, NgTemplateOutlet],
})
export class RequestCartGroupComponent {
  // TODO - Replace with actual cart group shape
  readonly group = input.required<FakeCartGroup>()
  readonly displayType = input.required<CartGroupDisplayType>()

  readonly itemTemplate =
    contentChild.required<TemplateRef<{ $implicit: FakeCartGroup['items'][number] }>>('itemTemplate')

  protected readonly dateFormat = DateFormat

  protected classes = computed<string>(() => `cart-group cart-group--${this.displayType()}`)
}
